export default "__VITE_ASSET__C99qCDYa__"